import type { PayloadAction } from "@reduxjs/toolkit"
import { createSlice } from "@reduxjs/toolkit"
import { AlertVariant } from "../../common/alert/Alert"
import { Alert } from "./alert"

const uuidv4 = require("uuid/v4")

export type DisplayAlertPayload = {
    type: AlertVariant
    message: string
}

type AlertsState = {
    active: Alert[]
}

const initialState: AlertsState = {
    active: [],
}

export const alertsSlice = createSlice({
    name: "alerts",
    initialState,
    reducers: {
        displayAlert: (state, action: PayloadAction<DisplayAlertPayload>) => {
            const id = uuidv4()
            state.active = [
                ...state.active,
                {
                    id,
                    type: action.payload.type,
                    message: action.payload.message,
                    dismissible: true,
                }
            ]
        },
        hideAlert: (state, action: PayloadAction<string>) => {
            state.active = state.active.filter(alert => alert.id !== action.payload)
        },
    },
})

export const { displayAlert, hideAlert } = alertsSlice.actions

export default alertsSlice.reducer


// WEBPACK FOOTER //
// ./src/state/alert/reducer.ts